import api from "@/services/api";

const base = "/notifications";

export const notificationsApi = {
  async unreadCount() {
    const { data } = await api.get(`${base}/unread-count`);
    const payload = data?.data ?? data;
    return Number(payload?.count ?? payload?.unread_count ?? 0);
  },

  async list(params = {}) {
    const { data } = await api.get(base, { params });
    return {
      items: data?.data ?? [],
      meta: data?.meta ?? {},
    };
  },

  async markRead(id) {
    const { data } = await api.patch(`${base}/${id}/read`);
    return data?.data ?? data;
  },

  async markAllRead() {
    const { data } = await api.post(`${base}/read-all`);
    return data?.data ?? data;
  },
};
